import { UsersTable } from './UsersTable';

export const UsersList: React.FC = () => {
  return <UsersTable />;
};
